<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace" id="ded"> </p>
<p class="ded">This book is dedicated to those dogs from which Damien was first drawn. To have known them was the honor of a lifetime, and the void felt now that they are gone proves false the saying “Time heals all things.”</p>
<p class="linespace"> </p>
<p class="ded"><span class="epub-i">In memory of The Three:</span></p>
<p class="half-space"> </p>
<p class="ded">ARROW</p>
<p class="ded">A yellow Labrador</p>
<p class="ded">Who taught me many things, but mostly that Damien exists, and that the friendship between a human and a dog truly can be among the closest bonds of this earth.</p>
<p class="half-space"> </p>
<p class="ded">OTTO</p>
<p class="ded">A Doberman</p>
<p class="ded">Who taught me all I ever needed to know about the heart.</p>
<p class="ded">And heart doctors.</p>
<p class="half-space"> </p>
<p class="ded">SAXON</p>
<p class="ded">A Doberman</p>
<p class="ded">A trust betrayed; she understands why I had to write this book.</p>
<p class="linespace"> </p>
<p class="ded"><span class="epub-i">And for The One:</span></p>
<p class="half-space"> </p>
<p class="ded">DREAD</p>
<p class="ded">A Pit Bulldog</p>
<p class="ded">With whom I shared a soul.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?02cd1dc3